<template>
    <div id="contract_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ContractHeader" v-if="$route.params.id > 0" >Update Contract</span>
                    <span class="page-title" id="ContractHeader"  v-else>Add Contract</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i>  Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contract-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ContractForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input disabled="disabled" type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{ code_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                        <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                label="text"
                                                :options="contractTypeArr">
                                        </v-select>
                                        <div class="field-error">{{ contract_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id" @input="onSelectCustomer($event)"

                                            label="text" :filterable="false" :options="customerArr"
                                            @search="onSearchCustomer"
                                            placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                            label="text"
                                            :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{ location_error_msg }}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="effective_date">Effective Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ effective_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_term">Contract Term:</label>
                                        <input type="text" class="form-control" v-model="contract_term" id="contract_term" placeholder="Enter Months." name="contract_term">
                                        <div class="field-error">{{ contract_term_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Expiry Date:</label>
                                        <input :readonly="editExpiryDate == 1" type="text" id="expiry_date" name="expiry_date" placeholder="Expiry Date" class="form-control" v-model="expiry_date">
                                        <div class="field-error">{{expiry_date_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="source_document">Source Document:</label>
                                        <input type="text" class="form-control" v-model="source_document" id="source_document" placeholder="Enter Source Document" name="source_document">
                                        <div class="field-error"></div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="cpi_code_id">Cpi Code:</label>
                                        <v-select v-model="cpi_code_id" name="cpi_code_id" placeholder="Select Cpi Code."
                                                label="text"
                                                :options="cpiCodeArr">
                                        </v-select>
                                        <div class="field-error">{{cpi_code_error}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="anniversary_point">Cpi Anniversary Point:</label>
                                        <v-select v-model="anniversary_point" name="anniversary_point" placeholder="Select Cpi Anniversary Point."
                                                label="text"
                                                :options="anniversaryPointArr">
                                        </v-select>
                                        <div class="field-error">{{cpi_anniversary_point_error}}</div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="frequency">Cpi Frequency:</label>
                                        <v-select
                                            class="close-remove"
                                            name="frequency"
                                            v-model="frequency"
                                            id="frequency" label="text"
                                            :options="frequencyArr"
                                            :require="true">
                                        </v-select>
                                        <div class="field-error">{{cpi_frequency_error}}</div>
                                    </div>
                                    <!-- <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label" for="termination_date">Termination Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="termination_date" name="termination_date" v-model="termination_date" :config="optionsDate"></date-picker>
                                            <label for="termination_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div> -->
                                    <!-- <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom">
                                                CPI Waived
                                                <input type="checkbox" v-model="cpi_waived" id="cpi_waived" name="cpi_waived">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div> -->
                                    <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom"> <input type="checkbox" v-model="consolidated" id="consolidated" name="consolidated">  Consolidate
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                     <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom">
                                                National Lease
                                                <input type="checkbox" v-model="national_lease" id="national_lease" name="national_lease">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createContractBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateContract" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createContractBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateContract" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueContractBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateContract(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelContractBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "ContractCreate",
  metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Contract | " +process.env.COPYRIGHT_NAME : "Create Contract | " +process.env.COPYRIGHT_NAME
        }
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    editExpiryDate:true,
    cantAccessPage: "",
    contract_id: "",
    code: "",
    contract_type_id: null,
    contractTypeArr: [],
    customer_id: null,
    customerArr: [],
    location_id: null,
    locationArr: [],
    // effective_date: "",
    // termination_date: "",
    // contract_term:"",
    // expiry_date: "",
    // contract_billing_method_id: null,
    // contractBillingMethodArr: [],
    //contract_billing_frequency_id: "",
//    contractBillingFrequencyArr: [],
    source_document: "",
    cpi_code_id: null,
    cpiCodeArr: [],
    // anniversary_point: null,
    anniversaryPointArr: [],
    // frequency: "",
    frequency: {value: "6", text: "6 Month"},
    frequencyArr: [
        {
            value: "6",
            text: "6 Month"
        },
        {
            value: "12",
            text: "12 Month"
        },
        {
            value: "18",
            text: "18 Month"
        },
        {
            value: "24",
            text: "24 Month"
        },
    ],
    loading:false,
    editContract:false,
    contract_type_error_msg: "",
    code_error_msg: "",
    customer_error_msg: "",
    location_error_msg: "",
    // effective_date_error_msg: "",
    // contract_term_error_msg:"",
    // expiry_date_error_msg: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    cpi_frequency_error: "",
    cpi_anniversary_point_error: "",
    cpi_code_error: "",
    // cpi_waived:false
    national_lease:false,
    consolidated:true
  }),
  watch:{

        //update expiry date on change effective value
        // effective_date: function(effDate) {

        //     if ( effDate != "" && effDate != null) {

        //         var contract_term = this.contract_term;
        //         if ( contract_term != "" ) {

        //             var effDate = new Date(effDate);
        //             console.log("month",effDate.getMonth() + 1 );
        //             effDate.setMonth(effDate.getMonth() + parseInt(contract_term));

        //             this.expiry_date = ('0' + (effDate.getMonth() + 1)).slice(-2) + "/" + ('0' + effDate.getDate()).slice(-2) + "/" + effDate.getFullYear();

        //         } else {
        //             this.expiry_date = "";
        //         }

        //     } else {
        //         // alert("in else  ")
        //         this.expiry_date = "";
        //     }

        // },
        // //update expiry date on change contract_term value
        // contract_term: function(contract_term) {

        //     if ( contract_term != "" ) {

        //         var efDate = this.effective_date;
        //         if ( efDate != "" ) {

        //             var effDate = new Date(efDate);
        //             console.log("month",effDate.getMonth() + 1 );
        //             effDate.setMonth(effDate.getMonth() + parseInt(contract_term));

        //             this.expiry_date = ('0' + (effDate.getMonth() + 1)).slice(-2) + "/" + ('0' + effDate.getDate()).slice(-2) + "/" + effDate.getFullYear();

        //         } else {
        //             this.expiry_date = "";
        //         }


        //     } else {
        //         this.expiry_date = "";
        //     }

        // },

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_contract' ) {
                        self.cantAccessPage = true;

                    }
                }
            }

        }

  },
  created: function() {
  },
  beforeRouteLeave(to, from, next) {
        var self = this;
        self.left_view_edit_channel(from.fullPath);
        next();
  },
  mounted: function() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        self.getPermissions();
        if (segments[3]) {
            self.loadFieldData(['contractType','location','contractBillingMethod','contractBillingFreq','cpiCode']);
            self.contract_id = segments[3];
            self.loadContract();

            //Join ViewEdit Channel
            self.join_view_edit_channel(segments[1],segments[2],segments[3]);
        } else {
            self.loadFieldData(['contractType','location','contractBillingMethod','contractBillingFreq','cpiCode'], 'create');
        }
        //self.contractData();
        self.anniversaryPointArr = self.cpiAnniversaryPointArr;
  },
  methods: {

    contractData(){

        var self = this;

        $.ajax({
              url: process.env.ROOT_API + "/get-contract-data",
              type: "get",
              crossDomain: true,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {

                  if (data.status == "success") {
                      if ( self.contract_id == "" ) {
                          self.code = data.content;
                      }

                  }

              },

              error: function (jqXHR, exception) {

                  //self.CheckBtn = 'Check';
                  self.generateStatusCodeMessage(jqXHR,false,'contract-data-get')
              }
          });
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    BackContractList() {
      var self = this;
      self.$router.push("/contract/list");
    },

    CreateContract(flag) {
        var self = this;
        var error = false;
        var codeError = "";
        self.code = String(self.code).trim();

        self.contract_type_error_msg = "";
        self.customer_error_msg = "";
        self.customer_error_msg = "";
        self.location_error_msg = "";
        // self.effective_date_error_msg = "";
        // self.contract_term_error_msg = "";
        self.cpi_code_error = "";
        self.cpi_anniversary_point_error = "";
        self.cpi_frequency_error = "";
        self.code_error_msg = "";
        // self.expiry_date_error_msg = "";

        if (self.contract_type_id == null || !self.contract_type_id.value) {
            self.contract_type_error_msg = "Contract Type require.";
            error = true;
        }

        if (self.customer_id == null || !self.customer_id.value) {
            self.customer_error_msg = "Customer Name is require.";
            error = true;
        }

        if (self.location_id == null || !self.location_id.value) {
            self.location_error_msg = "Location require.";
            error = true;
        }

        // if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
        //     self.effective_date_error_msg = "Effective Date require.";
        //     error = true;
        // }

        // if (!self.contract_term || self.contract_term == null || self.contract_term == "") {
        //     self.contract_term_error_msg = "Contract Term require.";
        //     error = true;
        // }

        // if (!self.expiry_date || self.expiry_date == null || self.expiry_date == "") {
        //     self.expiry_date_error_msg = "Expiry Date Required.";
        //     error = true;
        // }

        // if (!self.code || self.code == null || self.code == "") {
        //     self.code_error_msg = "Code require.";
        //     error = true;
        // }

        // codeError = self.validateLength(self.code, 1, 12);
        // if (codeError) {
        //   self.code_error_msg = codeError;
        //   error = true;
        // }

        // if (Date.parse(self.effective_date) > Date.parse(self.expiry_date)) {
        //     alert("Expiry Date should not be earlier than Effective Date");
        //     error = true;
        // }

        // if ((Date.parse(self.effective_date) >= Date.parse(self.termination_date)) || (Date.parse(self.expiry_date) <= Date.parse(self.termination_date))) {
        //     alert("Termination Date should be between Effective Date and Expiry Date");
        //     error = true;
        // }

        if(self.cpi_code_id == null || !self.cpi_code_id.value) {
            self.cpi_code_error = "Cpi Code is require."
            error = true;
        }

        // if(self.anniversary_point == null || !self.anniversary_point.value) {
        //     self.cpi_anniversary_point_error = "Cpi Anniversary Point is require.";
        //     error = true;
        // }

        if(self.frequency == null || !self.frequency.value) {
            self.cpi_frequency_error = "Cpi Frequency is require."
            error = true;
        }

        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createContractBtn").val("Updating ...");
                $("#createContractBtn").prop("disabled", true);
                $("#cancelContractBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueContractBtn").val("Saving ...");
                    $("#createContractBtn").prop("disabled", true);
                    $("#createAndContinueContractBtn").prop("disabled", true);
                    $("#cancelContractBtn").prop("disabled",true);

                }else{

                    $("#createContractBtn").val("Saving ...");
                    $("#createContractBtn").prop("disabled", true);
                    $("#createAndContinueContractBtn").prop("disabled", true);
                    $("#cancelContractBtn").prop("disabled",true);
                }

            }

            var fields = $("#ContractForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "contract_type_id", value: self.contract_type_id.value});
            fields.push({name: "customer_id", value: self.customer_id.value});
            fields.push({name: "location_id", value: self.location_id.value});
            fields.push({name: "frequency", value: self.frequency.value});
            // if ( self.cpi_waived == true ) {
            //     fields.push({name: "cpi_waived", value: 1});
            // }else{
            //     fields.push({name: "cpi_waived", value: 0});
            // }

            if ( self.national_lease == true ) {
                fields.push({name: "national_lease", value: 1});
            }else{
                fields.push({name: "national_lease", value: 0});
            }
            if ( self.consolidated == true ) {
                fields.push({name: "consolidated", value: 'yes'});
            }else{
                fields.push({name: "consolidated", value: 'no'});
            }

            // if (self.contract_billing_method_id == null) {
            //     fields.push({name: "contract_billing_method_id", value: ""});
            // } else{
            //     fields.push({name: "contract_billing_method_id", value: self.contract_billing_method_id.value});
            // }

            // if (self.contract_billing_frequency_id == null) {
            //     fields.push({name: "contract_billing_frequency_id", value: ""});
            // } else{
            //     fields.push({name: "contract_billing_frequency_id", value: self.contract_billing_frequency_id.value});
            // }

            /* if (self.cpi_code_id == null) {
                fields.push({name: "cpi_code_id", value: ""});
            } else{
                fields.push({name: "cpi_code_id", value: self.cpi_code_id.value});
            }

            if (self.anniversary_point == null) {
                fields.push({name: "anniversary_point", value: ""});
            } else{
                fields.push({name: "anniversary_point", value: self.anniversary_point.value});
            } */

            fields.push({name: "cpi_code_id", value: self.cpi_code_id.value});
            // fields.push({name: "anniversary_point", value: self.anniversary_point.value});
            $.ajax({
                url: process.env.ROOT_API + "/contract/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        self.editContract = true;
                        $("#createContractBtn").val("Update");
                        $("#createContractBtn").prop("disabled", false);
                        $("#cancelContractBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractBtn").val("Save and Continue");
                            $("#createContractBtn").prop("disabled", false);
                            $("#createAndContinueContractBtn").prop("disabled", false);
                            $("#cancelContractBtn").prop("disabled",false);

                        }else{

                            $("#createContractBtn").val("Save");
                            $("#createContractBtn").prop("disabled", false);
                            $("#createAndContinueContractBtn").prop("disabled", false);
                            $("#cancelContractBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if ( flag == "Save and Continue") {

                            // self.contractData();

                            self.contract_type_id = null;
                            self.customer_id = null;
                            self.location_id = null;
                            // self.effective_date = "";
                            // self.termination_date = "";
                            // self.contract_term = "";
                            // self.expiry_date = "";
                            // self.contract_billing_method_id = null;
                            //self.contract_billing_frequency_id = "";
                            self.source_document = "";
                            self.cpi_code_id = null;
                            // self.anniversary_point = null;
                            self.frequency = "";

                        } else {
                            // alert(data.content.contract_type_id + data.content.ctCode);
                            if(!self.editContract){
                                var params = encodeURI("contractName=" + data.content.code + "&contractId=" + data.content.id + "&contractTypeId=" + self.contract_type_id.value + "&contractTypeCode=" + self.contract_type_id.text + "&customerId=" + self.customer_id.value + "&customerName=" + self.customer_id.name + "&customerCode=" + self.customer_id.code);
                                self.$router.push("/contractassetdetail/add?"+params);
                            }
                            else{
                                self.BackContractList();
                            }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";

                            if (data.message == "errMsgContract") {

                                // err +=  "Contract " + data.content[0].code + " exits for this Contract Type " + self.titleCase(data.content[0].contName) + " & Customer " + self.titleCase(data.content[0].custName);
                                err +=  self.titleCase(data.content[0].contName) + "Contract Type already exists for this Customer Name " + self.titleCase(data.content[0].custName);

                            } else if (data.message == "errMsgEffectiveMonth"){

                                err += "Insert First Effective CPI Code for this month.";

                            } else {

                                for (var i = 0; i < data.content.length; i++) {

                                    if (data.content[i] == "The frequency must be a number.") {
                                        err += "The Cpi frequency must be a number." + "<br>";
                                    } else {
                                        err += data.content[i] + "<br>";
                                    }

                                }
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractBtn").val("Update");
                        $("#createContractBtn").prop("disabled", false);
                        $("#cancelContractBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractBtn").val("Save and Continue");
                            $("#createContractBtn").prop("disabled", false);
                            $("#createAndContinueContractBtn").prop("disabled", false);
                            $("#cancelContractBtn").prop("disabled",false);

                        }else{

                            $("#createContractBtn").val("Save");
                            $("#createContractBtn").prop("disabled", false);
                            $("#createAndContinueContractBtn").prop("disabled", false);
                            $("#cancelContractBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'contract-data-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadContract() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/contract/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                action_flag : 'edit', // pass action for notify: view, edit
                is_notify_flag : true // notify if user viewing or editing
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.contract_type_id = {value: data.content.contract_type_id, text: self.titleCase(data.content.ctName + " (" + data.content.ctCode +")")};
                    self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.customerName)};
                    self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locName + " (" + data.content.locCode +")")};
                    // self.effective_date = data.content.effective_date;
                    // self.termination_date = data.content.termination_date;
                    // self.contract_term = data.content.contract_term;
                    // self.expiry_date = data.content.expiry_date;

                    // if (data.content.cpi_waived == 1){
                    //     self.cpi_waived = true;
                    // }else{
                    //     self.cpi_waived = false;
                    // }

                    if (data.content.national_lease == 1){
                        self.national_lease = true;
                    }else{
                        self.national_lease = false;
                    }
                    if(data.content.consolidated == 'yes'){
                        $("#consolidated").prop("checked",true);
                        self.consolidated = true;
                    }else{
                        $("#consolidated").prop("checked",false);
                        self.consolidated = false;
                    }

                    // if(data.content.contract_billing_method_id == null) {
                    //     self.contract_billing_method_id = null;
                    // }else{
                    //     self.contract_billing_method_id = {value: data.content.contract_billing_method_id, text: self.titleCase(data.content.cbmName + " (" + data.content.cbmCode +")")};
                    // }

                    // if(data.content.contract_billing_frequency_id == null) {
                    //     self.contract_billing_frequency_id = "";
                    // }else{
                    //     self.contract_billing_frequency_id = {value: data.content.contract_billing_frequency_id, text: self.titleCase(data.content.cbfName + " (" + data.content.cbfCode +")")};
                    // }

                    if(data.content.cpi_code_id == null) {
                        self.cpi_code_id = null;
                    }else{
                        self.cpi_code_id = {value: data.content.cpi_code_id, text: self.titleCase(data.content.ccName + " (" + data.content.ccCode +")")};
                    }

                    self.source_document = data.content.source_document;

                    // for( var i=0; i<self.anniversaryPointArr.length;i++) {

                    //     if(data.content.anniversary_point == self.anniversaryPointArr[i]['value']){
                    //         self.anniversary_point = {value:data.content.anniversary_point,text:self.anniversaryPointArr[i]['text']};
                    //         // console.log('array value :: ' + self.anniversaryPointArr[i]['value'] + ' db value :: ' + data.content.anniversary_point);
                    //     }
                    // }

                    if (data.content.frequency == 0) {
                        self.frequency = {value: "", text: ""};
                    } else {
                        self.frequency = {value: data.content.frequency, text: data.content.frequency + " Month"};
                    }
                    self.code = data.content.code;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-contract-data')
            }
        });
    },
    onSelectCustomer:function(evt){
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        if (!segments[3]){
            if (self.customer_id.user_location && self.customer_id.user_location != ''){
                self.location_id = self.customer_id.user_location;
            }else
            if (self.customer_id.location && self.customer_id.location != ''){
                self.location_id = self.customer_id.location;
            }
        }
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ContractCreate.vue